import { render } from "./ActorNew.vue?vue&type=template&id=0fbeace6"
import script from "./ActorNew.vue?vue&type=script&lang=js"
export * from "./ActorNew.vue?vue&type=script&lang=js"
script.render = render

export default script